import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Honeybadger from '@honeybadger-io/js';

import HeaderText from '../../components/personal/HeaderText';
import SetTitle from '../../components/personal/SetTitle';
import { validateColorString } from '../../utilities/generic/Common'

import ArrivingOrLeavingComponent from '../../components/personal/ArrivingOrLeaving';

class ArrivingOrLeaving extends Component {

  state = {
    profile: null,
    loaded: false,
    error: null
  };

  render() {
    if (this.props.location.state === undefined) {
      return <Redirect to="/personal/404" />
    }

    const token = this.props.location.state.token

    const { profile, loaded, error, errors } = this.state;

    if (errors) {
      return (
        <div className="errors">
          Sorry, looks like you have some errors:
          <ul>
            {errors.errors.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      )
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded && profile) {
      return (
        <div className="main-page">
          <SetTitle title={"Arriving or Leaving"} profile={profile} />
          <HeaderText message={profile.welcome_message} />

          <div className="content">
            <div className="background">
              <div className="message">
                {profile.text_on_select}
              </div>

              <ArrivingOrLeavingComponent token={token} profile={profile} />
            </div>
          </div>

          <Link to={{ pathname: `/personal/new/${encodeURIComponent(token)}` }} className="widget">
            Back
          </Link>
        </div>
      );
    }
  }

  componentDidMount() {
    if (this.props.location.state === undefined) {
      return
    }

    const token = this.props.location.state.token

    var headers = new Headers();
    headers.append("Content-Type", "application/json");

    var json = JSON.stringify({
      "personal": {
        "token": token
      }
    })

    var requestOptions = {
      method: 'POST',
      headers: headers,
      body: json,
      redirect: 'follow'
    };

    var errorsInResponse = false

    fetch(`${process.env.REACT_APP_ROOT_DOMAIN}/v1/d/personal/pull`, requestOptions)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        else if (response.status === 401) {
          errorsInResponse = true
          return response.json();
        }
        else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(data => {
        if (errorsInResponse) {
          this.setState({ errors: data })
        } else {
          localStorage.setItem("background_image", JSON.stringify(data.background_image))
          localStorage.setItem("logo", JSON.stringify(data.logo))
          Honeybadger.setContext({
            locationName: data.location_name,
            profileName: data.name
          })
          this.setState({ profile: data, loaded: true })

          if (validateColorString(data.border_color)){
            document.querySelector(':root').style.setProperty('--page-border-color', data.border_color)
          }
          else {
            document.querySelector(':root').style.setProperty('--page-border-color', null)
          }

          if (localStorage.getItem("first_time") === null) {
            localStorage.setItem("first_time", true)
            window.location.reload()
          }
        }
      })
      .catch(error => this.setState({ error: error, loaded: true }))
  }
}

export default ArrivingOrLeaving;
